/* eslint-disable max-len */
import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import BasicOrderInformation from '../../BasicOrderInformartion/BasicOrderInformation';
import CrmOrderDetails from '../../../../classes/CrmOrderDetails';
import envConfig from '../../../../envConfig';
import checkIfUserIsSaml from '../../../../utility/checkIfUserIsSaml';
import { selectSessionInformation } from '../../../../redux/slices/sessionSlice';
import RaaAuthenticatedRemoteService from '../../../../utility/RaaAuthenticatedRemoteService';

function NoAccessOrderScreen({
  order, loadError, subscriptionId,
}) {
  const { activeSubscription } = useSelector(selectSessionInformation);
  const [isUserPending, setIsUserPending] = useState(false);
  const memoizedStatus = useMemo(() => order.shippingStatus,
    [order.shipmentList, order.shippingTimestamp]);
  const [isSamlUser, setIsSamlUser] = useState(false);

  const handleCheckIfPendingThisAccount = (pendingAssignArr) => pendingAssignArr
    .filter((assignment) => parseInt(assignment.subscriptionId, 10) === subscriptionId);

  const fetchPendingAssignment = () => {
    RaaAuthenticatedRemoteService.globalInstance().get(`${envConfig.apiUrl}/api/v1/user/pending-assignments`)
      .then((response) => {
        const { pendingAssignments } = response;
        if (pendingAssignments && pendingAssignments.length > 0) {
          setIsUserPending(
            handleCheckIfPendingThisAccount(pendingAssignments).length > 0,
          );
        }
      })
      .catch(() => {});
  };

  const handleManageRequest = () => {
    window.location.href = '/user/subscriptions';
  };

  React.useEffect(() => {
    fetchPendingAssignment();
  }, []);

  React.useEffect(() => setIsSamlUser(checkIfUserIsSaml(activeSubscription)), []);

  return (
    <div>
      <p>
        Basic information about your order is listed below. For additional details and order tracking,
        <b> please request access.</b>
      </p>
      <div className="row">
        <div className="col-auto mb-2">
          <BasicOrderInformation
            orderNumber={order.orderNumber}
            orderStatus={memoizedStatus}
            billingStatus={order.paymentType}
            orderPlacedOn={order.createdAtDisplay}
            shippingMethod={`${order.shipCarrier} ${order.shipMethod}`}
            loadError={loadError}
          />
        </div>

        <div className="col-lg-5 col-sm-12">
          {isUserPending
            ? (
              <div className="card bg-light" style={{ minHeight: '4rem' }}>
                <div className="card-body">
                  <div className="pb-3">
                    <p className="text-break">
                      You cannot view this order&apos;s details because you don&apos;t currently have access
                      to the Room Alert Account associated with this order. Account
                      associated with this quote. A message has been sent
                      to the owner of this account, asking them to grant you access.
                    </p>
                    <button
                      type="button"
                      className="btn btn-primary mt-3"
                      onClick={handleManageRequest}
                      data-testid="manage-request"
                    >
                      Manage Request
                    </button>
                  </div>
                </div>
              </div>
            )
            : (
              <div className="card bg-light" style={{ minHeight: '4rem' }}>
                <div className="card-body">
                  <div className="pb-3">
                    <p>
                      You cannot view this order&apos;s details because you don&apos;t currently have access to the Room Alert
                      Account associated with this order.
                    </p>
                    {!isSamlUser && (
                    <a href={`${envConfig.raaUrl}/user/add-subscription?by=ORD-${order.id}&referrer=/p/order/${order.id}`}>
                      <button
                        type="button"
                        className="btn btn-primary mt-3"
                      >
                        Request Account Access
                      </button>
                    </a>
                    )}
                  </div>
                </div>
              </div>
            )}
        </div>
      </div>
    </div>
  );
}

NoAccessOrderScreen.propTypes = {
  order: PropTypes.shape(CrmOrderDetails).isRequired,
  loadError: PropTypes.bool.isRequired,
  subscriptionId: PropTypes.number.isRequired,
};

export default NoAccessOrderScreen;
